import styled from 'styled-components'

export const SectionContainer = styled.div`
  margin: 0 auto;
  padding: 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media screen and (min-width: 768px) {
    max-width: var(--container-max-width);
  }
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`
